import React, { Component } from "react";
import Banners from "../components/banners";
import "./Home.css";

class HomeView extends Component {
  state = {};
  render() {
    return (
      <div id="home">
        <Banners />
      </div>
    );
  }
}

export default HomeView;
